import React from "react";
import NarrativeDisplay from "../NarrativeDisplay";

interface MarkdownViewerProps {
  content: string;
  className?: string;
}

/**
 * Reusable markdown viewer component that renders markdown with entity mentions.
 * This wraps the NarrativeDisplay component for consistent rendering across the app.
 */
export default function MarkdownViewer({
  content,
  className,
}: MarkdownViewerProps) {
  return (
    <div className={className}>
      <NarrativeDisplay narrativeText={content} />
    </div>
  );
}
